import { render, staticRenderFns } from "./ErroAtendimento.vue?vue&type=template&id=3473cd57&scoped=true&"
import script from "./ErroAtendimento.vue?vue&type=script&lang=js&"
export * from "./ErroAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./ErroAtendimento.vue?vue&type=style&index=0&id=3473cd57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3473cd57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
